import React from 'react';

const OurTeam = () => {
  const teamMembers = [
    {
      name: "Jack Hunt",
      title: "CEO & Founder",
      img: "https://randomuser.me/api/portraits/men/79.jpg",
      description:
        "Obsessed with making Gapalyze seller-first. Focuses on partnerships, platform reach, and seller success.",
    },
    {
      name: "Yash",
      title: "CMO",
      img: "https://randomuser.me/api/portraits/men/80.jpg",
      description:
        "Drives brand strategy and market expansion. Passionate about innovation and community building.",
    },
    {
      name: "Priya Sharma",
      title: "CTO",
      img: "https://randomuser.me/api/portraits/women/68.jpg",
      description:
        "Heads up the technology stack and product architecture. Loves building scalable solutions.",
    },
    {
      name: "Ravi Patel",
      title: "Head of Sales",
      img: "https://randomuser.me/api/portraits/men/74.jpg",
      description:
        "Leads the sales team with a growth mindset. Expert in B2B sales and client relationships.",
    },
    {
      name: "Neha Gupta",
      title: "Lead Designer",
      img: "https://randomuser.me/api/portraits/women/69.jpg",
      description:
        "Crafts elegant UI/UX designs that delight users. Focused on detail and user empathy.",
    },
    {
      name: "Amit Joshi",
      title: "Marketing Analyst",
      img: "https://randomuser.me/api/portraits/men/81.jpg",
      description:
        "Crunches the numbers to help shape marketing strategy. Loves working with data and insights.",
    },
    {
      name: "Sneha Verma",
      title: "Social Media Manager",
      img: "https://randomuser.me/api/portraits/women/65.jpg",
      description:
        "Curates content and grows online communities. Always on top of trends and engagement tactics.",
    },
    {
      name: "Karan Mehta",
      title: "Partnership Manager",
      img: "https://randomuser.me/api/portraits/men/83.jpg",
      description:
        "Builds and nurtures partnerships. Skilled in outreach and strategic growth alliances.",
    },
  ];

  return (
    <div className="team-container container py-5">
      <h6 className="text-uppercase text-muted text-center mb-2">Our Team</h6>
      <h3 className="fw-bold text-center mb-4">Meet the Marketers Behind Gapalyze</h3>
      <p className="text-center text-muted mb-5">We’re a team of creators, strategists, and builders empowering marketplace sellers to thrive.</p>

      <div className="row team-member">
        {teamMembers.map((member, index) => (
          <div className="col-md-6 col-lg-3 mb-4" key={index}>
            <div className="team-card text-center shadow-sm h-100 p-4">
              <img src={member.img} alt={member.name} className="team-profile mb-3" />
              <p className="team-role text-muted small">{member.title}</p>
              <h5 className="team-name">{member.name}</h5>
              <p className="team-desc text-muted small">{member.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurTeam;
